import { createContext } from "react";

export const NoteDataAccessContext = createContext(null);
